import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const quoteShipEngineShipmentCallable = httpsCallable(functions, 'quoteShipEngineShipment');
const createShipEngineLabelCallable = httpsCallable(functions, 'createShipEngineLabel');

export const quoteShipEngineShipment = async (payload) => {
  const response = await quoteShipEngineShipmentCallable(payload);
  return response?.data || {};
};

export const createShipEngineLabel = async (payload) => {
  const response = await createShipEngineLabelCallable(payload);
  return response?.data || {};
};

export const getShipEngineLabel = async (labelId) => {
  const response = await httpsCallable(functions, 'getShipEngineLabel')({ labelId });
  return response?.data || {};
};
